<template>
  <header class="ai-visibility-section-header">
    <div>
      <div class="ai-visibility-section-header__title">
        <h2>{{ title }}</h2>
        <info-icon v-if="infoTitle" :info="{tooltip: infoTitle}"/>
      </div>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>

  </header>
</template>

<script>
import InfoIcon from '../display/InfoIcon.vue'

export default {
  name: 'SectionHeader',
  components: {
    InfoIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    infoTitle: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-section-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: transparent;
  margin-bottom: 16px;

  .ai-visibility-section-header__title {
    display: flex;
    gap: 12px;
    align-items: center;
  }
}

.ai-visibility-section-header h2 {
  color: var(--v-mainColor-base);
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  margin: 0;
}

.ai-visibility-section-header p {
  color: var(--v-mainColor-base);
  font-size: 16px;
  line-height: 1.45;
  margin: 5px 0 0;
}
</style>
